// Consent is a recoverable pause, never an authorization revocation.
export async function legalAcceptanceRequired(response) {
  if (response.status !== 409) return null
  let acceptanceUrl = response.headers?.get("X-Legal-Acceptance-URL")
  if (!acceptanceUrl) {
    try {
      const body = await response.clone().json()
      if (body.error === "legal_acceptance_required") acceptanceUrl = body.acceptance_url
    } catch (_error) { return null }
  }
  return acceptanceUrl ? { status: "legal_acceptance_required", acceptanceUrl } : null
}

export function presentLegalAcceptance(result) {
  const document = globalThis.document
  if (!document?.createElement) return
  globalThis.dispatchEvent(new CustomEvent("legal-acceptance:required", { detail: result }))
  if (document.getElementById("legal-acceptance-notice")) return
  const notice = document.createElement("div")
  notice.id = "legal-acceptance-notice"
  notice.className = "flash-container"
  notice.style.zIndex = "2000"
  notice.setAttribute("role", "alert")
  const flash = document.createElement("div")
  flash.className = "flash"
  const link = document.createElement("a")
  link.className = "flash__message"
  link.style.color = "inherit"
  // A document navigation lets the server remember this page as the return path.
  const currentUrl = new URL(globalThis.location.href)
  const exempt = ["/help", "/terms-and-conditions", "/privacy-policy", "/legal_acceptance"].includes(currentUrl.pathname)
  const acceptanceUrl = new URL(result.acceptanceUrl, currentUrl)
  link.href = exempt && acceptanceUrl.origin === currentUrl.origin ? acceptanceUrl.href : currentUrl.href
  link.dataset.turbo = "false"
  link.textContent = document.querySelector("meta[name='legal-acceptance-label']")?.content || result.acceptanceUrl
  flash.append(link)
  notice.append(flash)
  document.body.append(notice)
}

export async function throwIfLegalAcceptanceRequired(response) {
  const result = await legalAcceptanceRequired(response)
  if (!result) return
  const error = new Error(result.status)
  error.code = result.status
  error.acceptanceUrl = result.acceptanceUrl
  throw error
}
